import { useIntercom } from 'hooks/useIntercom';

export const IntercomLauncher = (): null => {
  useIntercom();

  return null;
};

IntercomLauncher.displayName = 'IntercomLauncher';
